import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { reportError } from '@/lib/sentry';

export const queryClient = new QueryClient({
    // A screen turns a failed call into a toast, which tells the admin and nobody else. These
    // tell Sentry too, once per failure, after the retries; it drops the API's own refusals.
    queryCache: new QueryCache({ onError: reportError }),
    mutationCache: new MutationCache({ onError: reportError }),
    defaultOptions: {
        queries: {
            // the portal is read-heavy over slow-changing operational data
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: 0,
        },
    },
});
